import React, { ReactNode, useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import "./NavBar.css";
import { Skeleton } from "@mui/lab";
import { routes } from "../../routes/routes";
export interface NavbarProps {
  children?: ReactNode;
  logo?: string;
  variant?: "signup" | "signin" | "logoOnly";
}
const MinimalNavBar = ({
  children,
  logo,
  variant = "logoOnly",
}: NavbarProps) => {
  const navigate = useNavigate();
  const [orgId, setOrgId] = useState("");

  useEffect(() => {
    const organizationFromStorage = localStorage.getItem("orgId") ?? "";
    setOrgId(organizationFromStorage);
  }, []);

  const handleClick = (path: string) => {
    navigate(path);
  };

  const getContent = () => {
    if (variant === "signup") {
      return (
        <div
          className="navLinks"
          onClick={() => handleClick(`/${routes.public.signUp}`)}
        >
          <p style={{ color: "#59636E" }}>Sign Up</p>
        </div>
      );
    }
    if (variant === "signin") {
      return (
        <div
          className="navLinks"
          onClick={() => handleClick(`/${routes.public.signIn}`)}
        >
          <p style={{ color: "#59636E" }}>Sign In</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <AppBar
        position="fixed"
        color="default"
        elevation={4}
        sx={{
          backgroundColor: "#fff",
          fontFamily: "Poppins, sans-serif",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25) !important",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          top: 0,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingX: "25px !important",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              alignItems: "center",
              overflow: "visible",
              // marginRight: "20px",
            }}
          >
            <NavLink
              to={`/${routes.public.signIn}`}
              style={{ textDecoration: "none" }}
            >
              {!logo ? (
                <Skeleton
                  variant="rectangular"
                  sx={{
                    height: "30px",
                  }}
                />
              ) : (
                <img
                  src={logo}
                  alt="Logo"
                  style={{
                    height: "30px",
                    width: "auto",
                    cursor: "pointer",
                  }}
                />
              )}
            </NavLink>
          </Typography>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            {getContent()}
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ marginTop: "58px" }}>{children}</Box>
    </div>
  );
};

export default MinimalNavBar;
